export default __webpack_public_path__ + "static/media/29.e2630e05.jpg";